// extracted by mini-css-extract-plugin
export default {"pricing":"pricing__OTUxY","section":"section__MTU5N","title":"title__YWU2N","icon":"icon__OWQ0Z","link":"link__NDlmM"};